import { useState } from 'react';
import { Button, Tag as AntTag } from 'antd';
import styled from 'styled-components';
// import { getTagColor } from './tagFilterUtils';
import type { IBadge } from './types';

const VISIBLE_TAGS = 8;

interface ITagFilterProps {
  tags: IBadge[];
  disabled: Set<string>;
  showMoreText: string;
  showLessText: string;
  onToggle: (label: string) => void;
  onEnableAll: () => void;
  onDisableAll: () => void;
}

const TagFilter: React.FC<ITagFilterProps> = ({
  tags,
  disabled,
  showMoreText,
  showLessText,
  onToggle,
  onEnableAll,
  onDisableAll,
}) => {
  const [expanded, setExpanded] = useState(false);
  const hasMore = tags.length > VISIBLE_TAGS;
  const visibleTags = expanded ? tags : tags.slice(0, VISIBLE_TAGS);

  return (
    <Wrapper>
      <Actions>
        <Button type="link" size="small" onClick={onEnableAll}>
          Turn on all
        </Button>
        <Button type="link" size="small" onClick={onDisableAll}>
          Turn off all
        </Button>
      </Actions>
      <List>
        {visibleTags.map(tag => {
          const isOff = disabled.has(tag.label);
          return (
            <FilterTag
              key={tag.label}
              $off={isOff}
              // color={isOff ? 'default' : getTagColor(tag)}
              onClick={() => onToggle(tag.label)}
            >
              {tag.label}
            </FilterTag>
          );
        })}
      </List>
      {hasMore && (
        <Button type="link" size="small" onClick={() => setExpanded(e => !e)}>
          {expanded
            ? showLessText
            : `${showMoreText} (${tags.length - VISIBLE_TAGS})`}
        </Button>
      )}
    </Wrapper>
  );
};

export default TagFilter;

const Wrapper = styled.div`
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  gap: ${({ theme }) => theme.spacing.xs};
  margin-top: ${({ theme }) => theme.spacing.sm};
`;

const Actions = styled.div`
  display: flex;
  gap: ${({ theme }) => theme.spacing.sm};

  .ant-btn {
    padding: 0;
    height: auto;
  }
`;

const List = styled.div`
  display: flex;
  flex-wrap: wrap;
  gap: 4px;
`;

// Colored variant (antd `color={getTagColor(tag)}`): off state was
// `opacity: 0.6; color: theme.colors.textSecondary` via `css`.
const FilterTag = styled(AntTag)<{ $off: boolean }>`
  margin-inline-end: 0;
  cursor: pointer;
  user-select: none;
  border-color: transparent;
  background: ${({ $off, theme }) =>
    $off ? theme.colors.gray[100] : theme.colors.primaryLight};
  color: ${({ $off, theme }) =>
    $off ? theme.colors.gray[400] : theme.colors.primaryActive};
`;
